import Phaser from 'phaser';
import { Entity } from '../base/Entity';

export interface BehaviorConfig {
  [key: string]: unknown;
}

/**
 * Behavior - Base class for all entity behaviors
 *
 * Behaviors are reusable components that add functionality to entities.
 * Examples: HealthBehavior, WalkerBehavior, ShooterBehavior, etc.
 */
export class Behavior {
  public entity: Entity;
  public scene: Phaser.Scene;
  public enabled: boolean = true;
  public config: BehaviorConfig;

  constructor(entity: Entity, config: BehaviorConfig = {}) {
    this.entity = entity;
    this.scene = entity.scene;
    this.config = config;
  }

  /**
   * Called every frame when behavior is enabled
   */
  update(time: number, delta: number): void {
    // Override in subclasses
  }

  /**
   * Enable this behavior
   */
  enable(): void {
    this.enabled = true;
  }

  /**
   * Disable this behavior
   */
  disable(): void {
    this.enabled = false;
  }

  /**
   * Toggle this behavior
   */
  toggle(): void {
    this.enabled = !this.enabled;
  }

  /**
   * Clean up resources
   */
  destroy(): void {
    // Override in subclasses if needed
  }
}
